import {Model} from 'MWC';

const oneTimeCommission = 'one_time_commission',
    hundredPercent = 100,
    bankDays = 360,
    realRate = 'real_rate';

export default class extends Model {
    static fields;

    constructor(data, mode, list) {
        super();

        this.data = data;
        this.list = list;
        this.mode = mode;
        this._initVariables();
        this._initFields();
    }

    _initVariables() {
        this.creditSum = 100000;
        this.term = 0;
        this.oneTimeTrancheCommission = 0;
        this.trancheCommission = 0;
        this.trancheCost = 0;
    }

    _initFields() {
        this.fields = {
            ...this.data[this.mode]
        };
    }

    changeField(name, value) {
        this[name] = value;

        if (name === 'mode') {
            this._initVariables();
            this._initFields();
        }

        this.calculateIndicators();
    }

    getMinSumEdge() {
        return +this.fields.min;
    }

    getMaxSumEdge() {
        return +this.fields.max;
    }

    getSumStep() {
        return +this.fields.step;
    }

    getTerms() {
        return this.fields.terms;
    }

    getTerm() {
        return +this.term;
    }

    getTrancheTerm() {
        return this.fields.terms[this.term];
    }

    getTrancheRate() {
        return this.fields[realRate][this.term];
    }

    getOneTimeCommission() {
        return +this.fields[oneTimeCommission];
    }

    getCreditSum() {
        return +this.creditSum;
    }

    getOneTimeTrancheCommission() {
        return this.oneTimeTrancheCommission;
    }

    setOneTimeTrancheCommission(value) {
        this.oneTimeTrancheCommission = value;
    }

    getTrancheCommission() {
        return this.trancheCommission;
    }

    setTrancheCommission(value) {
        this.trancheCommission = value;
    }

    getTrancheCost() {
        return this.trancheCost;
    }

    setTrancheCost(value) {
        this.trancheCost = value;
    }

    сalcOneTimeCommission() {
        const sum = this.getCreditSum(),
            oneTimeCommissionRate = this.getOneTimeCommission();
        return this._round((sum * oneTimeCommissionRate) / hundredPercent);
    }

    getListOfCredits() {
        return this.list;
    }

    calculateIndicators() {
        const sum = this.getCreditSum(),
            oneTimeCommissionRate = this.getOneTimeCommission(),
            term = this.getTrancheTerm(),
            rate = this.getTrancheRate();

        const trancheOneTimeCommission = this._round(
                (sum * oneTimeCommissionRate) / hundredPercent
            ),
            trancheDayUsagePercent = (sum * rate) / hundredPercent / bankDays,
            trancheCommission = this._round(trancheDayUsagePercent * term),
            trancheTotalUsagePercent = trancheDayUsagePercent * term,
            trancheCost = this._round(trancheTotalUsagePercent + trancheOneTimeCommission);

        this.setOneTimeTrancheCommission(trancheOneTimeCommission);
        this.setTrancheCommission(trancheCommission);
        this.setTrancheCost(trancheCost);
    }

    _round(value) {
        return Math.round(value * hundredPercent) / hundredPercent;
    }
}
